import { gql } from '@apollo/client';

const query = gql`
  mutation toggleBookmark($id: ID, $type: UnitType) {
    toggleBookmark(id: $id, type: $type)
  }
`;

export default query;
